module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_4.a4f9afba.png";